const dateFormatter = new Intl.DateTimeFormat("zh-CN", {
  dateStyle: "medium",
  timeStyle: "short",
  hour12: false,
});

export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return "未知时间";
  }
  const timestamp = Date.parse(value);
  if (Number.isNaN(timestamp)) {
    return value;
  }
  return dateFormatter.format(timestamp);
}

export function formatAuthors(
  authors: string[],
  maxVisible = 3,
): { text: string; tooltip?: string } {
  if (!authors?.length) {
    return { text: "未知作者" };
  }
  if (authors.length <= maxVisible) {
    return { text: authors.join(", ") };
  }
  const visible = authors.slice(0, maxVisible).join(", ");
  return {
    text: `${visible} 等`,
    tooltip: authors.join(", "),
  };
}
